import React, { useEffect } from 'react';
import '../cs/temp.css';
import AOS from "aos";
import "aos/dist/aos.css";

function CrossPlatformSoftware() {
    useEffect(()=>{
        AOS.init({duration:1000,once:true});
    },[])
    return (
        <div className="webdev-page" style={{overflowX:"hidden"}}>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
                >
                    <div className="container" data-aos="fade-up">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">Cross-Platform Development</h1>
                        </div>
                    </div>
                </div>
            </section>

            {/* Our Solutions Section */}
            <section className="webdev-services-section">
                <div className="container">
                    <div className="section-header">
                        <h2 data-aos="fade-up">Our Cross-Platform Solutions</h2>
                        <p className="section-description">
                        We use modern cross-platform frameworks to create powerful applications that deliver a seamless experience across multiple devices and operating systems — all from a single, maintainable codebase.                        </p>
                    </div>

                    <div className="services-grid" data-aos="fade-up-left" data-aos-delay="200">
                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fab fa-react"></i>
                            </div>
                            <h3>React Native Apps</h3>
                            <p>Develop high-performance apps with React Native, combining JavaScript flexibility with native components for a smooth user experience.
</p>
                        </div>

                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fab fa-google"></i>
                            </div>
                            <h3>Flutter Apps</h3>
                            <p>Build visually stunning, natively compiled apps using Flutter and Dart, complete with customizable widgets and beautiful animations.
</p>
                        </div>

                        {/* <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-layer-group"></i>
                            </div>
                            <h3>Multi-Platform UI</h3>
                            <p>Adaptive interfaces that maintain platform conventions while sharing code.</p>
                        </div> */}

                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-laptop-code"></i>
                            </div>
                            <h3>Web & Mobile</h3>
                            <p>Deliver unified experiences across mobile apps and responsive web platforms through shared codebases and design consistency.</p>
                        </div>
                    </div>
                </div>
            </section>


            {/* Development Process Section */}
            <section className="design-process-section">
                <div className="container">
                    <div className="section-header">
                        <h2 data-aos="fade-up">Our Cross-Platform Development Process</h2>
                        <p className="section-description">
                            A streamlined approach to building multi-platform applications efficiently
                        </p>
                    </div>

                    <div className="process-timeline">
                        <div className="process-step" data-aos="fade-left" data-aos-delay="200">
                            <div className="step-number">1</div>
                            <div className="step-content">
                                <h3>Requirement Analysis</h3>
                                <p>Understand your business objectives, audience, and required features to plan the ideal solution.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="200">
                            <div className="step-number">2</div>
                            <div className="step-content">
                                <h3>UI/UX Design</h3>
                                <p>Design adaptive, platform-conscious interfaces that feel natural on iOS, Android, and web platforms.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="200">
                            <div className="step-number">3</div>
                            <div className="step-content">
                                <h3>Cross-Platform Development</h3>
                                <p>Build applications using React Native, Flutter, or similar frameworks to create one codebase for multiple environments.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="300">
                            <div className="step-number">4</div>
                            <div className="step-content">
                                <h3>Native Bridge Integration</h3>
                                <p>Add native integrations where needed to utilize device-specific features like biometrics, GPS, and sensors.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="300">
                            <div className="step-number">5</div>
                            <div className="step-content">
                                <h3>Quality Assurance</h3>
                                <p>Test extensively on all supported platforms to ensure flawless performance and user experience.</p>
                            </div>
                        </div>

                        <div className="process-step" data-aos="fade-left" data-aos-delay="300">
                            <div className="step-number">6</div>
                            <div className="step-content">
                                <h3>Deployment & Support</h3>
                                <p>Launch your app across app stores and platforms, followed by ongoing updates and support.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="why-choose-section">
                <div className="container">
                    <div className="section-header">
                        <h2>Technologies We Use</h2>
                        <p className="section-description">
                        Cross-platform development offers strategic advantages for speed, quality, and cost-effectiveness:                        </p>
                    </div>

                    <div className="features-grid" data-aos="fade-up-left">
                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fab fa-apple"></i>
                            </div>
                            <h3>Shared Codebase</h3>
                            <p> Write once, deploy everywhere — minimizing repetitive coding efforts..</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fab fa-android"></i>
                            </div>
                            <h3>Near-Native Performance</h3>
                            <p> Optimized rendering engines and native component integration deliver a smooth user experience.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fab fa-react"></i>
                            </div>
                            <h3>React Native</h3>
                            <p>A single codebase for both iOS and Android with near-native performance.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fab fa-google"></i>
                            </div>
                            <h3>Consistent Design</h3>
                            <p> A unified codebase ensures a cohesive look and feel across platforms.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fas fa-database"></i>
                            </div>
                            <h3>Faster Development</h3>
                            <p> Streamlined processes reduce build times significantly compared to separate native development.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon text-center">
                                <i className="fas fa-lock"></i>
                            </div>
                            <h3>Cost Savings</h3>
                            <p> Shared logic and code reduce both initial development and future maintenance costs.</p>
                        </div>
                    </div>
                </div>
            </section>


            {/* CTA Section */}
            <section className="cta-section mt-5">
                <div className="container">
                    <div className="cta-content">
                        <h2>Ready to Build Once, Deploy Everywhere?</h2>
                        <p>Let's discuss how our cross-platform solutions can save you time and money while reaching users on all devices.</p>
                        <a href="/contact" className="cta-button">Get a Free Consultation</a>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default CrossPlatformSoftware;
